import { render, staticRenderFns } from "./WorkDefaultContactPicker.vue?vue&type=template&id=c781b644"
import script from "./WorkDefaultContactPicker.vue?vue&type=script&lang=js"
export * from "./WorkDefaultContactPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports